import { ReceiptHeaderImage } from './Extras/receipt-header-image';

export class StaticVariable {

    // static porturl = 'http://192.168.43.163:8081/TicketBookingApi/';
    // static porturl = 'http://192.168.43.214:8082/TicketBookingApi/'; 
    
    // static porturl = 'http://192.168.29.196:8090/TicketBookingApi/';
    static porturl = 'http://war.thirucadaiyurtemple.org/TicketBookingApi/';
    
    // static porturl = 'http://192.168.0.120:8082/TicketBookingSoftwareApi-v1/';
    // static porturl = 'http://eticket.samayapurammariammantemple.org:8080/SamayapuramTicketBookingApi/';


    // static porturl = 'http://148.66.133.79:8080/TirukkadaiyurAbiramiTicketBookingApi/';

    static TempleName = 'Arulmigu Amirtha Kadeswarar Temple';
    static District = 'Thirukkadavur';
    static Pincode = '609 311';
    static Email = '';
    static receiptBanner = ReceiptHeaderImage.receiptBanner;
    static status_1 = 'INITIAL';
    static status_2 = 'SUCCESS';
    static status_3 = 'FAILED';
    static status_4 = 'PENDING';
    static smsEncryptOffset = 25;
    static technicalSupport = '';
    static mail1 = '';
    static mail2 = '';
    static landLine = '04364 - 287429';
    static tollFree = '';
    static pgKey1 = 'SxwgqL';
    static pgKey2 = '';
    static pgSalt1 = 'zC7VUYYY';
    static pgSalt2 = '';
}